import { render, staticRenderFns } from "./module6.vue?vue&type=template&id=07936e78&scoped=true"
import script from "./module6.vue?vue&type=script&lang=js"
export * from "./module6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07936e78",
  null
  
)

export default component.exports